import CollectionRow from './CollectionRow.container'

export default CollectionRow
